module.exports = __webpack_public_path__ + "flashfood-counter-mockup.svg?a8f5d93ed7db9ece6e2db134c63a5fdc";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/flashfood-counter-mockup.svg
// module id = 315
// module chunks = 0